/**
 @since 2021-08-11
 @author wj_tams_dev02
 @developer wj_tams_dev02
 */
import resultFactory from '~/utils/resultFactory'

export const state = () => ({
  txtCommonPolicyUrl: '/api/cm/anmly-prtc',
  txtCommonPolicySyncUrl: '/api/cm/anmly-prtc-sync',
  getCommonPolicyData: [], // 침입 탐지 공동 정책(메인 화면) 테이블 데이터
  getProtocolData: [], // 비정상 프로토콜 데이터(공동 정책 추가, 편집용)
  rowSelectItems: {},
  innerPolicyList: [],
  popupData: []
})

export const mutations = {
  initStore (state) {
    state.abnormalProtocolList = []
    state.originAbnormalProtocolList = []
  },
  clearStore: (state) => {
    state.getCommonPolicyData = []
    state.getProtocolData = []
    state.rowSelectItems = {} // 공동 정책 선택
    state.popupData = [] // 추가, 편집 결과 반영용 데이터
  },
  setRowSelectItems: (state, data) => {
    state.rowSelectItems = _.cloneDeep(data)
  },
  getCommonPolicyData: (state, data) => { // 칩입 탐지 공통 정책 조회
    state.getCommonPolicyData = _.cloneDeep(data)
  },
  getCommonPolicyDetailDataAction: (state, data) => { // 침입 탐지 공통 정책 상세 조회(비정상 프로토콜 조회)
    state.getProtocolData = _.cloneDeep(data)
  },
  getInnerPolicyListAction: (state, data) => { // 초기 비정상 프로토콜 목록 조회
    state.innerPolicyList = _.cloneDeep(data.ngips_anmly_prtc_list)
  },
  addCommonPolicyData: (state, data) => {
    const resultData = {
      ngips_anmly_prtc_cm_id: data.ngips_anmly_prtc_cm_id,
      ngips_anmly_prtc_cm_sync_yn: 0,
      ngips_anmly_prtc_cm_uname: state.popupData.ngips_anmly_prtc_cm_uname,
      ngips_anmly_prtc_cm_desc: state.popupData.ngips_anmly_prtc_cm_desc,
      device_name_list: state.popupData.device_name_list
    }
    state.getCommonPolicyData.unshift(resultData)
  },
  editCommonPolicyDataAction: (state) => {
    state.getCommonPolicyData = _.map(state.getCommonPolicyData, (item) => {
      if (item.ngips_anmly_prtc_cm_id === state.popupData.ngips_anmly_prtc_cm_id) {
        item.ngips_anmly_prtc_cm_uname = state.popupData.ngips_anmly_prtc_cm_uname
        item.ngips_anmly_prtc_cm_desc = state.popupData.ngips_anmly_prtc_cm_desc
        item.device_name_list = state.popupData.device_name_list
      }
      return item
    })
  },
  syncTable: (state, payload) => {
    state.popupData = _.cloneDeep(payload)
  },
  policyHeaderMutation: (state, data) => {
    state.getCommonPolicyData = _.map(state.getCommonPolicyData, (item) => {
      item.ngips_anmly_prtc_cm_sync_yn = data
      return item
    })
  }
}

export const actions = {
  // 칩입 탐지 공통 정책 조회
  async getCommonPolicyDataAction ({commit, state}) {
    try {
      const data = await this.$axios.$get(state.txtCommonPolicyUrl)
      return resultFactory(commit, {length: null, data: data, action: 'getCommonPolicyData', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 침입 탐지 공통 정책 상세 조회(비정상 프로토콜 조회)
  async getCommonPolicyDetailDataAction ({commit, state}) {
    try {
      const data = await this.$axios.$get(`${state.txtCommonPolicyUrl}/${state.rowSelectItems[0].ngips_anmly_prtc_cm_id}`)
      return resultFactory(commit, {length: null, data: data, action: 'getCommonPolicyDetailDataAction', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 침입 탐지 공통 정책 추가시, 초기 비정상 프로토콜 목록 조회
  async getInnerPolicyListAction ({commit, state}) {
    try {
      const data = await this.$axios.$get(`${state.txtCommonPolicyUrl}/0`)
      return resultFactory(commit, {length: null, data: data, action: 'getInnerPolicyListAction', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 칩입탐지 공동 정책 추가
  async addCommonPolicyDataAction ({commit, state}, payload) {
    try {
      const data = await this.$axios.$post(state.txtCommonPolicyUrl, payload)
      return resultFactory(commit, {length: null, data: data, action: 'addCommonPolicyData', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 칩입탐지 공동 정책 편집
  async editCommonPolicyDataAction ({commit, state}, payload) {
    try {
      const data = await this.$axios.$put(`${state.txtCommonPolicyUrl}`, payload)
      return resultFactory(commit, {length: null, data: data, action: 'editCommonPolicyDataAction', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 칩입탐지 공동 정책 일괄수정 (error 처리 완료)
  async editCommonPolicyDataListDataAction ({commit, state, dispatch}, payload) {
    try {
      const data = await this.$axios.$put(state.txtCommonPolicySyncUrl, {ngips_anmly_prtc_cm_sync_list: payload}, {successAlert: false})
      return resultFactory(commit, {length: payload.length, data: data, action: null, param: 'edit'})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 칩입탐지 공동 정책 삭제
  async delCommonPolicyDataAction ({commit, state}) {
    let isMulty = false
    const idList = []
    if (state.rowSelectItems.length > 1) {
      isMulty = true
      state.rowSelectItems.forEach((item) => {
        idList.push({'ngips_anmly_prtc_cm_id': item.ngips_anmly_prtc_cm_id})
      })
    }
    try {
      const data = isMulty ? await this.$axios.$delete(state.txtCommonPolicyUrl, {data: {ngips_anmly_prtc_cm_id_list: idList}}, {failAlert: false})
        : await this.$axios.$delete(`${state.txtCommonPolicyUrl}/${state.rowSelectItems[0].ngips_anmly_prtc_cm_id}`)
      return resultFactory(commit, {length: idList.length, data: data, action: null, param: 'delete'})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async commitAndRollBackPage ({commit, state}, type) {
    try {
      let msg = {}
      if (type === 'apply') {
        msg = {applyMsg: true}
      } else if (type === 'cancel') {
        msg = {cancelMsg: true}
      }
      const data = await this.$axios.$put(`${state.txtCommonPolicyUrl}/${type}`, null, msg)
      if (data.code !== 'ok') {
        return false
      }
      this.dispatch(`common/common/setIsChanged`, false)
      return 'ok'
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  }
}
